export type IdentityResolverDelegate = (...sessionData: any[]) => string;
